import axios, { AxiosResponse } from 'axios'

import { NotificationCenterHeaderName, NotificationCenterLog } from '@/entities/NotificationCenter/NotificationCenter'

export interface Credentials {
    username: string
    password: string
}

export const authenticateUserRequest = (credentials: Credentials): Promise<AxiosResponse> => (
    axios.post(`${process.env.REACT_APP_API_URL}/auth/token`, credentials)
)

export const refreshAccessToken = (refreshToken: string): Promise<AxiosResponse> => (
    axios.post(`${process.env.REACT_APP_API_URL}/auth/token/refresh`, {
        refresh_token: refreshToken,
    })
)

export const patchUserPassword = (
    userId: string,
    password: string,
    pincode: string,
    eventLogTrackerData?: NotificationCenterLog,
): Promise<AxiosResponse> => {
    const body = {
        type: 'users',
        id: userId,
        attributes: {
            ...(password && { password }),
            ...(pincode && { pincode }),
        },
    }

    return axios.patch(
        `${process.env.REACT_APP_API_URL}/users/${userId}`,
        { data: body },
        {
            headers: {
                [NotificationCenterHeaderName.X_EVENT]: JSON.stringify(eventLogTrackerData),
            },
        },
    )
}

export const postForgotPassword = (email: string): Promise<AxiosResponse> => (
    axios.post(`${process.env.REACT_APP_API_URL}/auth/forgot-password/${email}`)
)
